import styled from 'styled-components';
import {media} from '../../../theme';

export const Header = styled.div`
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    flex-direction: column;
    align-items: flex-start;

    button {
      width: 100%;
    }

    h2 {
      margin: 0;
      flex: 1;
    }

    ${media.sm} {
      flex-direction: row;
      align-items: center;

      button {
        width: auto;
      }
    }
`;

export const StyledDocumentButton = styled.button`
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    color: inherit;
    text-align: left;
    font-family: inherit;
    font-size: inherit;
    text-decoration: underline;
    
    &:hover {
        text-decoration: none;
    }
`;